/* shop/components/delivery/StandardDelivery.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	space,
	text
} from "svelte/internal";

import orderStore, {
	isDeliveryAvailableForPersonalPickup
} from "./../../orderStore";

import basketStore from "./../../basketStore";

function create_if_block_1(ctx) {
	let small;
	let t_value = /*deliveryItem*/ ctx[0].subtitle + "";
	let t;

	return {
		c() {
			small = element("small");
			t = text(t_value);
		},
		m(target, anchor) {
			insert(target, small, anchor);
			append(small, t);
		},
		p(ctx, dirty) {
			if (dirty & /*deliveryItem*/ 1 && t_value !== (t_value = /*deliveryItem*/ ctx[0].subtitle + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(small);
		}
	};
}

// (23:4) {#if deliveryItem.price}
function create_if_block(ctx) {
	let t0;
	let t1_value = /*deliveryItem*/ ctx[0].price + "";
	let t1;
	let t2;
	let t3_value = /*$basketStore*/ ctx[2].payment_currency + "";
	let t3;

	return {
		c() {
			t0 = text(": ");
			t1 = text(t1_value);
			t2 = space();
			t3 = text(t3_value);
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, t2, anchor);
			insert(target, t3, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*deliveryItem*/ 1 && t1_value !== (t1_value = /*deliveryItem*/ ctx[0].price + "")) set_data(t1, t1_value);
			if (dirty & /*$basketStore*/ 4 && t3_value !== (t3_value = /*$basketStore*/ ctx[2].payment_currency + "")) set_data(t3, t3_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
			if (detaching) detach(t3);
		}
	};
}

function create_fragment(ctx) {
	let input;
	let input_id_value;
	let input_checked_value;
	let t0;
	let label;
	let t1_value = /*deliveryItem*/ ctx[0].title + "";
	let t1;
	let t2;
	let t3;
	let label_for_value;
	let mounted;
	let dispose;
	let if_block0 = /*deliveryItem*/ ctx[0].subtitle && create_if_block_1(ctx);
	let if_block1 = /*deliveryItem*/ ctx[0].price && create_if_block(ctx);

	return {
		c() {
			input = element("input");
			t0 = space();
			label = element("label");
			t1 = text(t1_value);
			t2 = space();
			if (if_block0) if_block0.c();
			t3 = space();
			if (if_block1) if_block1.c();
			attr(input, "type", "radio");
			attr(input, "class", "radok");
			attr(input, "id", input_id_value = "delivery_" + /*deliveryItem*/ ctx[0].id);
			input.checked = input_checked_value = /*$orderStore*/ ctx[1].delivery_title == /*deliveryItem*/ ctx[0].title;
			attr(label, "for", label_for_value = "delivery_" + /*deliveryItem*/ ctx[0].id);
		},
		m(target, anchor) {
			insert(target, input, anchor);
			insert(target, t0, anchor);
			insert(target, label, anchor);
			append(label, t1);
			append(label, t2);
			if (if_block0) if_block0.m(label, null);
			append(label, t3);
			if (if_block1) if_block1.m(label, null);

			if (!mounted) {
				dispose = listen(input, "click", /*click_handler*/ ctx[3]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*deliveryItem*/ 1 && input_id_value !== (input_id_value = "delivery_" + /*deliveryItem*/ ctx[0].id)) {
				attr(input, "id", input_id_value);
			}

			if (dirty & /*$orderStore, deliveryItem*/ 3 && input_checked_value !== (input_checked_value = /*$orderStore*/ ctx[1].delivery_title == /*deliveryItem*/ ctx[0].title)) {
				input.checked = input_checked_value;
			}

			if (dirty & /*deliveryItem*/ 1 && t1_value !== (t1_value = /*deliveryItem*/ ctx[0].title + "")) set_data(t1, t1_value);

			if (/*deliveryItem*/ ctx[0].subtitle) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(label, t3);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*deliveryItem*/ ctx[0].price) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(label, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*deliveryItem*/ 1 && label_for_value !== (label_for_value = "delivery_" + /*deliveryItem*/ ctx[0].id)) {
				attr(label, "for", label_for_value);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(input);
			if (detaching) detach(t0);
			if (detaching) detach(label);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			mounted = false;
			dispose();
		}
	};
}

const type = "standard";

function instance($$self, $$props, $$invalidate) {
	let $orderStore;
	let $basketStore;
	component_subscribe($$self, orderStore, $$value => $$invalidate(1, $orderStore = $$value));
	component_subscribe($$self, basketStore, $$value => $$invalidate(2, $basketStore = $$value));
	let { deliveryItem } = $$props;

	const click_handler = () => {
		orderStore.setDelivery(deliveryItem.id, type, deliveryItem.title, deliveryItem.price, {}, deliveryItem.type_is_personal_pickup || false, deliveryItem.payment_methods);
	};

	$$self.$$set = $$props => {
		if ('deliveryItem' in $$props) $$invalidate(0, deliveryItem = $$props.deliveryItem);
	};

	return [deliveryItem, $orderStore, $basketStore, click_handler];
}

class StandardDelivery extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { deliveryItem: 0 });
	}
}

export default StandardDelivery;